import { render, staticRenderFns } from "./StudentListGraduated.vue?vue&type=template&id=37118d20"
import script from "./StudentListGraduated.vue?vue&type=script&lang=ts"
export * from "./StudentListGraduated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports